let safeLocalStorageInstance: Storage | undefined;
try {
  safeLocalStorageInstance = localStorage;
} catch {
  // Storage might not be available in some scenarios due to tracking protection.
  // Tracking protection settings are immutable within session so it is okay to detect
  // that state only once during app lifetime.
}

let safeSessionStorageInstance: Storage | undefined;
try {
  safeSessionStorageInstance = sessionStorage;
} catch {
  // Storage might not be available in some scenarios due to tracking protection.
  // Tracking protection settings are immutable within session so it is okay to detect
  // that state only once during app lifetime.
}

/**
 * Use this method to get browser local storage. Local storage object is returned, if available.
 * Otherwise, undefined is returned. Browser allows user to control whether persisted local storage
 * is supported via settings. There are various level of control where user can disable
 * persisted storage for specific site, inside incognito mode or everywhere. This is done to prevent
 * tracking user actions that can survive browser restarts.
 */
export function safeLocalStorage(): Storage | undefined {
  return safeLocalStorageInstance;
}

/**
 * Use this method to get browser session storage. Session storage object is returned, if available.
 * Otherwise, undefined is returned. Browser allows user to control whether session storage is supported
 * via settings. There are various level of control where user can disable session storage for specific
 * site, inside incognito mode or everywhere. This is done to prevent tracking user actions that can
 * survive page reload.
 */
export function safeSessionStorage(): Storage | undefined {
  return safeSessionStorageInstance;
}
